import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=0a44792f"
var script = {}
import style0 from "./TopBar.vue?vue&type=style&index=0&id=0a44792f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports